<div
  class="body"
  *ngIf="!loading"
  [class.body-game]="pageSrv.displayOnlyMain || !isLogged"
  [class.body-with-sidebar]="isLogged && !pageSrv.displayOnlyMain">
  <ng-container *ngIf="langSrcSrv.current">
    <app-sidebar *ngIf="isLogged && !pageSrv.displayOnlyMain"></app-sidebar>
    <div id="main" class="main-content">
      <app-page-header *ngIf="isLogged && !pageSrv.displayOnlyMain"></app-page-header>
      <div class="gs-page-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </ng-container>
</div>

<app-admin-toolbar *ngIf="!loading && isAdmin"></app-admin-toolbar>
